import React, {Component} from 'react';
import translate from '../../services/translation';

export default class Loading extends Component {


	render() {
		return (
			<div className="paginationLoaderContainer">
				<span className="loadingIconContainer">
					{translate('pagination.load')}
				</span>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Filter/Loading.js